import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  Container,
  Grid,
  CardMedia,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ReactPlayer from "react-player";

// import { stateToHTML } from "draft-js-export-html";
// import { Editor, EditorState, convertToRaw, convertFromRaw } from "draft-js";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionRoot: {
      background: "white",
      // minHeight: "90vh",
      marginTop: "10rem",
      marginBottom: "8%",
      //   padding: "0 4.948% 109px 4.948%",
      paddingLeft: "6rem",
      paddingRight: "6rem",
      [theme.breakpoints.down("xs")]: {
        marginTop: "5rem",

        paddingLeft: 32,
        paddingRight: 32,
      },
    },
    sectionRoot2: {
      background: "white",
      minHeight: "55vh",
      // marginTop: "8%",
      marginBottom: "8%",
      //   padding: "0 4.948% 109px 4.948%",
      // paddingLeft: "6rem",
      // paddingRight: "6rem",
      // paddingTop: "56.25%",
      // backgroundSize: "100%",
      // backgroundPosition: "50% 50%",
    },
    categoryText: {
      // fontFamily:"Black Han Sans"
      fontFamily: "Noto Sans KR",
      fontSize: 48,
      color: "black",
      fontWeight: 900,
      letterSpacing: -4,
      paddingBottom: 16,
    },
    subCategory: {
        fontFamily: "Noto Sans KR",
      fontSize: 40,
      color: "black",
      fontWeight: 500,
      //   paddingLeft:6
      letterSpacing: -1,
    },
    winnerDiv: {
      // paddingTop: "4rem"
    },
    winnerCategory: {
      fontSize: 20,
      fontWeight: 900,
      paddingRight: 32,
      //   color: "#7a5f50",
      color: "black",
      fontFamily: "Noto Sans KR",
      paddingBottom: 8,
    },
    winnerName: {
      fontSize: 20,
      fontWeight: 400,
      color: "black",
      fontFamily: "Noto Sans KR",
    },
    winnerTopDiv: {
      //   display: "flex",
      paddingBottom: 32,
    },

    topContainer: {
      paddingBottom: "6rem",
    },

    videoContainer: {
      padding: 24,
      [theme.breakpoints.down("xs")]: { padding: 0, paddingBottom: 16 },
    },

    videoBigTitle: {
      fontSize: 24,
      fontWeight: 900,
      fontFamily: "Noto Sans KR",
      margin: 0,
    },

    videoTitle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontFamily: "Noto Sans KR",
      fontWeight: 600,
      paddingBottom: 16,
      [theme.breakpoints.down("xs")]: { padding: 0, paddingBottom: 8 },
    },
  })
);
interface VideoOneLayoutProps {
  // history: History;
  urlArray: any;
}

function ConcertVideoOne({ urlArray }: VideoOneLayoutProps) {
  // const { history } = props;

  const classes = useStyles();
  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container
      maxWidth={"xl"}
      disableGutters={true}
      className={classes.sectionRoot}
    >
      <Grid xs={12} item>
        <Grid xs={12} item alignItems="center" container>
          {urlArray ? (
            <React.Fragment>
              <Grid xs={12} item container>
                {/* <VideoLibraryIcon /> */}
                <p className={classes.videoBigTitle}>비디오 자료</p>
              </Grid>
              <Grid xs={12} item container>
                {urlArray.map((video: any, index: any) => {
                  return (
                    <Grid
                      xs={12}
                      sm={12}
                      className={classes.videoContainer}
                      item
                      key={`video-gallery-${video.title}-${index}`}
                    >
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{}}
                        className={classes.videoTitle}
                      >
                        {video.title}
                      </Typography>
                      <ReactPlayer
                        url={`${video.url}`}
                        width={`100%`}
                        height={`${!mdMatches ? "945px" : "176px"}`}
                        controls={true}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </React.Fragment>
          ) : (
            <div></div>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}

export default ConcertVideoOne;
